
interface LoadingPageProps {
  text?: string;
}

export const LoadingPage: React.FC<LoadingPageProps> = ({ text }) => {
  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="spinner-border text-primary" role="status">
        <span className="sr-only text-black">Loading...</span>
      </div>
      <span className="text-primary fs-5 mx-2">
       { text ?? 'Secure' }
      </span>
    </div>
  )
}
